import { SliderField } from '../../dependencies';
export default SliderField;